import { Paper } from '@material-ui/core';
import { useStyles } from '@webapps/styles';
import { resolvePath } from '@webapps/utils';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import Autocomplete from '../components/Autocomplete';
import { FormikTextFieldPx, FormikTextInput } from '..';
import { css } from '@emotion/css';

const FormikAutocompleteInput = ({
  defaultValue = "",
  formik,
  label,
  multiple,
  name,
  placeholder,
  pathValue,
  endAdornment,
  completed,
  borderRadius = 400,
  options: propOptions,
  onChange: propOnChange,
  customHandler,
  showError = true,
  ...props
}) => {
  const { setFieldValue, values, handleBlur, handleChange: formikHandleChange } = formik;
  const { theme: { fontSizes } } = useStyles();
  const [options, setOptions] = useState(propOptions || []);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (customHandler?.fetchOptions) {
      customHandler.fetchOptions(inputValue, setOptions);
    }
  }, [inputValue, customHandler]);

  const handleChange = (event, value) => {
    let newValue;
    if (pathValue) {
      if (multiple) {
        newValue = value.reduce(
          (acc, cur) => [...acc, resolvePath(cur, pathValue, defaultValue)],
          []
        );
      } else {
        newValue = resolvePath(value, pathValue, defaultValue);
      }
    } else {
      newValue = value;
    }

    if (propOnChange) {
      propOnChange(event, newValue);
    } else if (customHandler?.onChange) {
      customHandler.onChange(event, formik, newValue);
    } else {
      setFieldValue(name, newValue, true);
    }
  };

  return (
    <Autocomplete
      multiple={multiple}
      onChange={handleChange}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue || ''); // Ensure newInputValue is a string
      }}
      className={
        css({
          '.MuiInputBase-root': {
            borderRadius: borderRadius,
          }
        })
      }
      PaperComponent={({ children }) =>
        <Paper style={{ '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' }, }}>{children}</Paper>
      }
      popupIcon={endAdornment || null}
      options={customHandler?.fetchOptions ? options : propOptions}
      value={resolvePath(values, name, defaultValue)}
      renderInput={(params) => (
        <FormikTextInput
          formik={formik}
          label={label}
          name={name}
          placeholder={placeholder}
          completed={completed}
          borderRadius={borderRadius}
          error={showError && !!resolvePath(formik.touched, name, '') && !!resolvePath(formik.errors, name, '')}
          helperText={showError && resolvePath(formik.touched, name, '') && resolvePath(formik.errors, name, '')}
          onBlur={handleBlur}
          {...params}
        />
      )}
      {...props}
    />
  );
};

FormikAutocompleteInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.node,
  formik: PropTypes.object,
  pathValue: PropTypes.string,
  defaultValue: PropTypes.any,
  multiple: PropTypes.bool,
  options: PropTypes.array,
  onChange: PropTypes.func,
  customHandler: PropTypes.object,
  showError: PropTypes.bool,
  endAdornment: PropTypes.node,
  completed: PropTypes.bool,
  borderRadius: PropTypes.number,
};

export default FormikAutocompleteInput;